<template>
    <div>
        <h3 class="page-title">学生</h3>
        <div class="toolbar" v-if="isAdmin">
            <el-button type="success" size="small" @click="studentFormVisible = true">添加学员</el-button>
        </div>
        <div class="filters">
            <el-form :inline="true" :model="params" ref="filterForm" class="demo-form-inline">
                <el-form-item prop="name" label="姓名">
                    <el-input size="small" v-model="params.name"  type="text" placeholder="输入学生名称" ></el-input>
                </el-form-item>
                <el-form-item prop="email" label="电子邮箱">
                    <el-input size="small" v-model="params.email"  type="text" placeholder="输入学生邮箱" ></el-input>
                </el-form-item>
                <el-form-item  style="width: 100px" prop="status" label="帐号状态">
                    <el-select style="width: 100px" size="small" v-model="params.status" placeholder="选择学生状态">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="活跃" value="enable"></el-option>
                        <el-option label="非活跃" value="disable"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  style="width: 100px" prop="account_type" label="帐号类型">
                    <el-select style="width: 100px" size="small" v-model="params.account_type" placeholder="选择账号类型">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="访客" value="guest"></el-option>
                        <el-option label="学员" value="member"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="search">查找</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" @click="clear">清除</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table v-loading="loading" empty-text="无数据" :data="dataList" stripe style="width: 100%" @sort-change="sortChange">
                <el-table-column prop="name" label="姓名">
                    <template slot-scope="scope">
                        {{scope.row.first_name}} {{scope.row.last_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="cellphone" label="联系电话"></el-table-column>
                <el-table-column prop="email" label="电子邮箱"></el-table-column>
                <el-table-column prop="skype" label="Skype"></el-table-column>
                <el-table-column prop="provider" align="center" label="注册方式"></el-table-column>
                <el-table-column prop="created_at" label="注册时间" align="center" sortable="custom">
                    <template slot-scope="scope">
                        {{scope.row.created_at | dateFormat}}
                    </template>
                </el-table-column>
                <el-table-column prop="account_type" align="center" label="帐号类型">
                  <template slot-scope="scope">
                        <el-tag v-if="scope.row.account_type === 'member'" type="success" size="mini">学员</el-tag>
                        <el-tag v-else size="mini" type="info">访客</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="帐号状态" align="center" width="80">
                    <template slot-scope="scope">
                        <el-switch
                            :disabled="!isAdmin"
                            v-model="scope.row.status"
                            active-value="enable"
                            inactive-value="disable"
                            @change="handleStatusSwitch(scope.row, $event)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="courses_count" align="center" label="所在班级数量">
                    <template slot-scope="scope">
                      <router-link :to="{ path: `/homework/student/${scope.row.id}/course`, query: { student_name: `${scope.row.first_name} ${scope.row.last_name}` } }">
                        {{scope.row.courses_count}}
                      </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" v-if="isAdmin">
                    <template slot-scope="scope">
                        <el-button
                            plain
                            type="success"
                            size="mini"
                            @click="courseSelect(scope.row)" icon="el-icon-plus"></el-button>
                        <el-button
                            plain
                            type="warning"
                            size="mini"
                            @click="edit(scope.row)" icon="el-icon-edit"></el-button>
                        <el-button
                            plain
                            type="danger"
                            size="mini"
                            @click="del(scope.row)" icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="params.page"
                :page-sizes="[20, 50, 100]"
                :page-size="params.per_page"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="Create Student" :visible.sync="studentFormVisible">
            <el-form :model="studentForm" ref="studentForm" :rules="registRules" label-width="180px">
              <el-form-item prop="first_name" label="名">
                <el-input v-model="studentForm.first_name"></el-input>
              </el-form-item>
              <el-form-item prop="last_name" label="姓">
                <el-input v-model="studentForm.last_name"></el-input>
              </el-form-item>
              <el-form-item prop="email" label="电子邮箱">
                <el-input v-model="studentForm.email"></el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input type="password" v-model="studentForm.password"></el-input>
              </el-form-item>
              <el-form-item prop="password_confirmation" label="确认密码">
                <el-input type="password" v-model="studentForm.password_confirmation"></el-input>
              </el-form-item>
              <el-form-item prop="cellphone" label="联系电话">
                <el-input v-model="studentForm.cellphone"></el-input>
              </el-form-item>
              <el-form-item prop="skype" label="Skype">
                <el-input v-model="studentForm.skype"></el-input>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="regist">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="Edit User" :visible.sync="editFormVisible">
          <div style="margin-bottom: 20px">
            <el-radio-group v-model="editForm.by">
              <el-radio label="info">修改资料</el-radio>
              <el-radio label="password">修改密码</el-radio>
            </el-radio-group>
          </div>
          <template v-if="editForm.by === 'password'">
            <el-form :model="editForm" ref="editForm" :rules="editPasswordRules" label-width="120px">
              <el-form-item prop="password" label="新密码">
                <el-input v-model="editForm.password"></el-input>
              </el-form-item>
              <el-form-item prop="password_confirmation" label="确认密码">
                <el-input v-model="editForm.password_confirmation"></el-input>
              </el-form-item>
            </el-form>
          </template>
          <template v-else>
            <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="180px">
              <el-form-item prop="first_name" label="名">
                <el-input v-model="editForm.first_name"></el-input>
              </el-form-item>
              <el-form-item prop="last_name" label="姓">
                <el-input v-model="editForm.last_name"></el-input>
              </el-form-item>
              <el-form-item prop="email" label="邮箱">
                <el-input v-model="editForm.email" disabled></el-input>
              </el-form-item>
              <el-form-item prop="cellphone" label="联系电话">
                <el-input v-model="editForm.cellphone"></el-input>
              </el-form-item>
              <el-form-item prop="skype" label="Skype">
                <el-input v-model="editForm.skype"></el-input>
              </el-form-item>
            </el-form>
          </template>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="save">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="加入班级" :visible.sync="courseSelectFormVisible">
            <el-form :model="courseSelectForm" ref="courseSelectForm" :rules="courseSelectFormRules" label-width="80px">
                <el-form-item prop="course_id" label="班级">
                    <el-select
                        size="small"
                        v-model="courseSelectForm.course_id"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="输入班级名称"
                        :remote-method="getCourseList"
                        :loading="courseLoading">
                        <el-option
                          v-for="item in courseList"
                          :key="item.id"
                          :label="item.name + ' - ' + item.teacher_name"
                          :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="addStudentToCourse">确认</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请重新输入密码'))
      } else if (value !== this.studentForm.password) {
        callback(new Error('请确认两次密码一致!'))
      } else {
        callback()
      }
    }

    var validatePass3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请重新输入密码'))
      } else if (value !== this.editForm.password) {
        callback(new Error('请确认两次密码一致!'))
      } else {
        callback()
      }
    }

    var cellphone = (rule, value, callback) => {
      if (/[\(\)\-\+\d.]+/.test(value) || value == '') {
        callback()
      } else {
        callback(new Error('请确认电话号码为数字'))
      };
    }

    return {
      total: 0,
      loading: true,
      params: {
        name: '',
        status: '',
        account_type: '',
        email: '',
        teacher_id: this.$store.state.user_profile.admin
          ? ''
          : this.$store.state.user_profile.id,
        page: 1,
        per_page: 20,
        order_by: [],
        fields: []
      },
      dataList: [],
      studentFormVisible: false,
      studentForm: {
        provider: 'email',
        email: '',
        password: '',
        password_confirmation: '',
        first_name: '',
        last_name: '',
        skype: '',
        cellphone: ''
      },
      registRules: {
        first_name: [
          { required: true, message: '名不能为空' }
        ],
        last_name: [
          { required: true, message: '姓不能为空' }
        ],
        email: [
          { required: true, type: 'email', message: '邮箱格式错误' }
        ],
        password: [
          { required: true, message: '密码不能为空' },
          {
            min: 6,
            max: 64,
            message: '请确认密码至少6位'
          }
        ],
        password_confirmation: [
          {
            required: true,
            validator: validatePass2,
            message: '两次密码不一致'
          }
        ],
        cellphone: [{ validator: cellphone }]
      },
      editFormVisible: false,
      edit_id: '',
      editForm: {
        by: 'info',
        skype: '',
        cellphone: '',
        email: '',
        first_name: '',
        last_name: '',
        password: '',
        password_confirmation: ''
      },
      editRules: {
        first_name: [
          { required: true, message: '名不能为空' }
        ],
        last_name: [{ required: true, message: '姓不能为空' }],
        email: [
          { type: 'email', message: '请输入正确的邮箱' }
        ]
      },
      editPasswordRules: {
        password: [
          { required: true, message: '密码不能为空' },
          { min: 6, max: 200, message: '请确认密码至少6位' }
        ],
        password_confirmation: [
          { required: true, validator: validatePass3, message: '两次密码不一致' }
        ]
      },
      courseSelectFormRules: {
        course_id: [{ required: true, message: '请选择班级' }]
      },
      courseLoading: false,
      courseList: [],
      courseSelectFormVisible: false,
      courseSelectForm: {
        student_id: '',
        course_id: ''
      }
    }
  },

  created () {
    this.getDataList()
  },
  computed: {
    ...mapGetters(['isAdmin', 'user_profile'])
  },
  methods: {
    addStudentToCourse () {
      if (!this.courseSelectForm.student_id) return
      if (!this.courseSelectForm.course_id) return
      this.$api.courses.add_student(this.courseSelectForm.course_id, this.courseSelectForm.student_id).then(data => {
        this.$message({
          type: 'success',
          message: `加入成功!`
        })
        this.courseSelectForm.course_id = ''
        this.courseSelectForm.student_id = ''
        this.courseSelectFormVisible = false
      }).catch(err => {
        console.log(err)
      })
    },
    getCourseList (name) {
      this.courseLoading = true
      var params = Object.assign({}, { fields: ['id', 'name'], status: 'enable', page: 1, per_page: 100, name })
      this.$api.courses.list(params).then(data => {
        this.courseList = data.data
        this.courseLoading = false
      }).catch(err => {
        console.log(err)
        this.courseLoading = false
      })
    },
    courseSelect (target) {
      this.courseSelectForm = {
        student_id: target.id
      }
      this.courseSelectFormVisible = true
    },
    sortChange ({ column, prop, order }) {
      this.params.order_by[0] = prop
        ? `${prop},${order == 'ascending' ? 'asc' : 'desc'}`
        : undefined
      this.getDataList()
    },
    getDataList () {
      this.loading = true
      let params = this.params
      !this.isAdmin && (params.teacher_id = this.user_profile.id)
      this.$api.students
        .list(this.params)
        .then(data => {
          this.total = data.total
          this.dataList = data.data
          this.loading = false
        })
        .catch(err => {
          this.$error(err)
          this.loading = false
        })
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getDataList()
    },
    handleSizeChange (size) {
      this.params.per_page = size
      this.getDataList()
    },
    handleStatusSwitch (target, new_state) {
      let type = 'warning'
      let action = '非活跃'
      let id = target.id

      let isEnable = new_state === 'enable'

      if (isEnable) {
        type = 'success'
        action = '活跃'
      }

      this.$confirm(`你确认设置[${target.name}]为${action}状态?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: type
      })
        .then(() => {
          if (isEnable) {
            this.$api.users
              .enable(id)
              .then(data => {
                target.status = 'enable'
                this.$message({
                  type: 'success',
                  message: action + '成功!'
                })
              })
              .catch(err => {
                target.status = 'disable'
                this.$error(err)
              })
          } else {
            this.$api.users
              .disable(id)
              .then(data => {
                target.status = 'disable'
                this.$message({
                  type: 'success',
                  message: action + '成功!'
                })
              })
              .catch(err => {
                target.status = 'enable'
                this.$error(err)
              })
          }
        })
        .catch(() => {
          target.status = target.status === 'disable' ? 'enable' : 'disable'
        })
    },
    setAdmin (target) {
      this.$confirm(`你确认设置 [${target.name}] 为管理员?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.users
            .set_admin(target.id)
            .then(data => {
              target.admin = true
              this.$message({
                type: 'success',
                message: '设置成功!'
              })
            })
            .catch(err => {
              this.$error(err)
            })
        })
        .catch(() => {})
    },
    setTeacher (target) {
      this.$confirm(`你确认设置 [${target.name}] 为教师?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.teachers
            .create(target.id)
            .then(data => {
              target.admin = true
              this.$message({
                type: 'success',
                message: '设置成功!'
              })
            })
            .catch(err => {
              this.$error(err)
            })
        })
        .catch(() => {})
    },
    del (target) {
      if (target.courses_count > 0) {
        this.$alert(`该学生有${target.courses_count}课程，请退出这些课程然后删除！`, { type: 'warning' })
        return
      }
      this.$confirm(`你确认删除学生 [${target.name}]?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.users
            .delete(target.id)
            .then(data => {
              this.$message({
                type: 'success',
                message: `${target.name}已被删除!`
              })
              this.getDataList()
            })
            .catch(err => {
              this.$error(err)
            })
        })
        .catch(() => {})
    },
    search () {
      // this.params.teacher_id = "";
      this.getDataList()
    },
    clear () {
      this.$refs['filterForm'].resetFields()
      this.getDataList()
    },
    edit (target) {
      this.edit_id = target.id
      this.editForm.by = 'info'
      this.editForm.password = ''
      this.editForm.password_confirmation = ''
      this.editForm.first_name = target.first_name
      this.editForm.last_name = target.last_name
      this.editForm.skype = target.skype
      this.editForm.cellphone = target.cellphone
      this.editForm.email = target.email
      this.editFormVisible = true
    },
    cancel () {
      this.$refs['studentForm'] && this.$refs['studentForm'].resetFields()
      this.edit_id = ''
      this.$refs['editForm'] && this.$refs['editForm'].resetFields()
      this.studentFormVisible = false
      this.editFormVisible = false
      this.courseSelectForm.student_id = ''
      this.courseSelectForm.course_id = ''
      this.courseSelectFormVisible = false
    },
    save () {
      if (this.editForm.by === 'password') {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            this.$api.users.savePassword(this.edit_id, this.editForm).then(data => {
              this.$message({
                type: 'success',
                message: `Modify Password Success!`
              })
              this.$refs['editForm'].resetFields()
              this.getDataList()
              this.editFormVisible = false
            }).catch(err => this.$error(err))
          }
        })
      } else {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            this.$api.users.save(this.edit_id, this.editForm).then(data => {
              this.$message({
                type: 'success',
                message: `Update User Success!`
              })
              this.$refs['editForm'].resetFields()
              this.getDataList()
              this.editFormVisible = false
            }).catch(err => this.$error(err))
          }
        })
      }
    },
    regist () {
      this.$refs['studentForm'].validate(valid => {
        if (valid) {
          this.$api.users
            .create(this.studentForm)
            .then(data => {
              this.$message({
                type: 'success',
                message: `创建学生信息成功！`
              })
              this.$refs['studentForm'].resetFields()
              this.studentFormVisible = false
              this.getDataList()
            })
            .catch(err => this.$error(err))
        }
      })
    }
  }
}
</script>
